
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/faq/customer",
      function () {
        return require("private-next-pages/faq/customer.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/faq/customer"])
      });
    }
  